import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export default function render(_ctx, _cache) {
  return (_openBlock(), _createBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, [
    _createVNode("path", { d: "M12.54 7.165c.5-.162.901-.543 1.091-1.03l4.233 4.234c-.486.19-.867.591-1.03 1.092L12.54 7.165zM16.835 12.54l-4.296 4.295c.5.162.902.543 1.092 1.03l4.233-4.234a1.755 1.755 0 01-1.03-1.092zM11.46 16.835l-4.295-4.296c-.162.5-.542.902-1.03 1.092l4.234 4.233c.19-.487.591-.867 1.092-1.03zM11.46 7.165l-4.295 4.296a1.755 1.755 0 00-1.03-1.092l4.234-4.233c.19.487.591.867 1.092 1.03z" }),
    _createVNode("path", {
      "fill-rule": "evenodd",
      d: "M12 4.5a1 1 0 100 2 1 1 0 000-2zm-2.5 1a2.5 2.5 0 115 0 2.5 2.5 0 01-5 0z",
      "clip-rule": "evenodd"
    }),
    _createVNode("circle", {
      cx: "12",
      cy: "18.5",
      r: "2.5"
    }),
    _createVNode("circle", {
      cx: "5.5",
      cy: "12",
      r: "2.5"
    }),
    _createVNode("circle", {
      cx: "18.5",
      cy: "12",
      r: "2.5"
    })
  ]))
}